


























import MarkdownContent from '@/components/MarkdownContent.vue';
import Modal from '@/components/mixins/Modal';

export default Modal.extend({
    components: {
        MarkdownContent,
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        message: {
            type: String,
            required: true,
        },
        markdown: {
            type: Boolean,
            default: false,
        },
        acceptLabel: {
            type: String,
            default: 'OK',
        },
        cancelLabel: {
            type: String,
            default: 'Cancel',
        },
    },
});
